export default __webpack_public_path__ + "static/media/093-redo-1.e590a8f4.png";